module.exports = __webpack_public_path__ + "img/SearchDepth.e5fae978.gif";